import { apiErrorHttpStatus } from "@youm-front/api/data-access";

/**
 * Why a conf2 (LiveE) sign-in failed, as far as the user needs to know.
 * "session-unavailable": the API answered 404 - the session has no Youm room.
 * "unknown": anything else (internal error, network).
 * The error is what ApiService throws (the response body), so the HTTP status
 * is read from ApiService, not from the body.
 */
export type Conf2SignInFailureReason = "session-unavailable" | "unknown";

export function conf2SignInFailureReason(
  error: unknown
): Conf2SignInFailureReason {
  return apiErrorHttpStatus(error) === 404 ? "session-unavailable" : "unknown";
}
